import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=0b7e7d3e&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e7d3e')) {
      api.createRecord('0b7e7d3e', component.options)
    } else {
      api.reload('0b7e7d3e', component.options)
    }
    module.hot.accept("./checkbox-group.vue?vue&type=template&id=0b7e7d3e&", function () {
      api.rerender('0b7e7d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox/checkbox-group.vue"
export default component.exports